<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row
            dense
            no-gutters
            class="mb-5 text-center text-md-left subtitle-1"
          >
            <v-col cols="12" lg="3">
              Total commission:
              <v-avatar :size="$gold_coin_sm"
                ><img :src="$goldCoinWhite" alt="coin"
              /></v-avatar>
              <strong>{{
                setsettings != 1
                  ? "TBP"
                  : total_commission | toNumberWithDecimal
              }}</strong>
            </v-col>
          </v-row>
          <v-row dense class="d-flex justify-end mt-n2">
            <v-col cols="12" md="6" lg="5" xl="2" :class="($hideifuserisSupervisor())">
              <agent-credit-autocomplete-template
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>
            <v-col cols="12" md="6" lg="5" xl="2">
              <v-select
                solo
                single-line
                dense
                clearable
                :items="drawlist"
                item-value="id"
                item-text="name"
                label="Draw"
                v-model="filter.draw"
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption"
                    >(+{{ filter.draw.length - 1 }})</span
                  >
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6" lg="5" xl="2">
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    single-line
                    dense
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col
              cols="12"
              md="1"
              :class="$vuetify.breakpoint.mobile ? 'mb-2' : ''"
            >
              <v-btn
                color="custom_info"
                class="float-right btn-block"
                @click="getDataFromApi()"
                ><v-icon>mdi-magnify</v-icon></v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.total_commission`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{
                    setsettings != 1
                      ? "TBP"
                      : item.total_commission == null
                      ? 0.0
                      : item.total_commission | toNumberWithDecimal
                  }}</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      setsettings: null,
      dt_headers: [
        {
          text: "Sub-agent",
          value: "username",
          name: "username",
          sortable: false,
          searchable: false,
        },
        {
          text: "Parent agent",
          value: "parent_name",
          name: "parent_name",
          sortable: false,
          searchable: false,
        },
        {
          text: "Level",
          value: "level",
          name: "level",
          sortable: false,
          searchable: false,
        },
        {
          text: "Commission",
          value: "total_commission",
          name: "total_commission",
          sortable: false,
          searchable: false,
        },
        // { text: 'Previous week', value: 'previous_commission', name: 'previous_commission', sortable: false, searchable: false},
        // { text: 'Current week', value: 'current_commission', name: 'current_commission', sortable: false, searchable: false},
        // { text: 'Daily', value: 'daily', name: 'daily', sortable: false, searchable: false},
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",

      total_commission: 0,
      total_previousWeek: 0,
      total_currentWeek: 0,
      total_daily: 0,

      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        roles: {},
        user_status: 1,
      }),

      filter: {
        datefrom: null,
        dateto: null,
        draw: [],
        daterange: null,
        status: null,
        agent_id:
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null,
      },
      filter_datedialog: null,
      drawlist: [],
    };
  },
  methods: {
    paramsfilter() {
      let agent_id,
        from,
        to = "";

      if (this.$refs.agent_autocomplete) {
        agent_id =
          this.$refs.agent_autocomplete.autocomplete_model != undefined
            ? this.$refs.agent_autocomplete.autocomplete_model.id
            : 0;
      }

      if (this.filter.daterange) {
        from = this.$moment(this.filter.daterange[0]).format("MM-DD-YYYY");
        to = this.$moment(this.filter.daterange[1]).format("MM-DD-YYYY");
      }

      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        draw: this.filter.draw.join(","),
        from: from,
        to: to,
        agent_id: this.filter.agent_id,
        reload: this.dt_reload,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = await this.$_CONFIG.api("API_COMMISSION");

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.total_commission = res.data.totalCommission;
          this.total_previousWeek = res.data.previousWeek;
          this.total_currentWeek = res.data.currentWeek;
          this.total_daily = res.data.daily;

          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSettings() {
      this.$axios
        .get(this.$_CONFIG.api("API_SETTINGS"))
        .then((data) => {
          this.setsettings = data.data["publish"];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getdrawlist();
    this.getDataFromApi();
    this.getSettings();
  },
  mounted() {
    // console.log(this.$moment().format("YYYY-MM-DD"))
  },
};
</script>
<style scoped></style>